(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hilltop-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.__hnTstc) return;
      root.__hnTstc = true;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hn-tstc-slide]'));
      var wrap = root.closest('.hn-testimonials--carousel') || document;
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-hn-tstc-dot]'));
      if (slides.length < 2) return;
      var i = 0;
      function show(n, dir) {
        root.setAttribute('data-dir', dir);
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        // force reflow so the incoming slide picks up the new direction transform
        void slides[i].offsetWidth;
        slides[i].classList.add('is-active');
        slides[i].removeAttribute('aria-hidden');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      var prev = root.querySelector('[data-hn-tstc-prev]');
      var next = root.querySelector('[data-hn-tstc-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1, 'prev'); });
      if (next) next.addEventListener('click', function () { show(i + 1, 'next'); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n, n > i ? 'next' : 'prev'); }); });
    }
    function initAll() { document.querySelectorAll('[data-hn-tstc]').forEach(initCarousel); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
